var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "mode",
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "custom-class": "confirm-dialog",
        top: "5vh",
        width: "320px",
        visible: _vm.show,
        center: "",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [_vm._v(_vm._s(_vm.msg))]),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            {
              staticClass: "flex_start flex_center_align",
              staticStyle: { width: "100%" },
              style: {
                width: !_vm.enableCancel ? "100%" : "auto",
              },
            },
            [
              _vm.enableCancel
                ? _c(
                    "div",
                    {
                      staticClass: "quxiao",
                      class: { pd_25: _vm.msgWidth !== "104px" },
                      on: { click: _vm.handleCancel },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.noText ? _vm.noText : "キャンセル") +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "changebtn",
                  class: { w104: _vm.enableCancel && _vm.msgWidth === "104px" },
                  style: {
                    backgroundColor: _vm.yesColor,
                    borderColor: _vm.yesColor,
                    width: !_vm.enableCancel ? "100%" : _vm.msgWidth,
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(" " + _vm._s(_vm.yesText ? _vm.yesText : "確定") + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }